import React from "react";
import "./ProgressBar.scss";

const isModuleCompleted = (module) => {
  return module.checked;
};

const getModuleProgression = (module, answers) => {
  const questionsCount = module.questions.length;

  if (questionsCount === 0) {
    return 0;
  }

  if (isModuleCompleted(module)) {
    return 100;
  }

  return (answers.length / questionsCount) * 100;
};

const getModuleAnswers = (answers, index) => {
  return answers[index] ?? [];
};

const ProgressBar = ({ modules, answers }) => {
  return (
    <div className="progress_bar">
      {modules.map((module, index) => {
        const moduleAnswers = getModuleAnswers(answers, index);

        return (
          <div key={index} className="progress_step">
            <div
              className="filler"
              style={{
                width: getModuleProgression(module, moduleAnswers) + "%",
              }}
            ></div>
          </div>
        );
      })}
    </div>
  );
};

export default ProgressBar;
